function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.679 1.731l-4.95 4.95a.989.989 0 01-.732.288.99.99 0 01-.732-.288l-2.95-2.95a1 1 0 011.414-1.414l2.268 2.268L8.266.317a.999.999 0 111.413 1.414z"
});

var SvgMark2 = function SvgMark2(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI3IiB2aWV3Qm94PSIwIDAgMTAgNyI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTkuNjc5IDEuNzMxbC00Ljk1IDQuOTVhLjk4OS45ODkgMCAwIDEtLjczMi4yODguOTkuOTkgMCAwIDEtLjczMi0uMjg4bC0yLjk1LTIuOTVhMSAxIDAgMCAxIDEuNDE0LTEuNDE0bDIuMjY4IDIuMjY4TDguMjY2LjMxN2EuOTk5Ljk5OSAwIDEgMSAxLjQxMyAxLjQxNHoiLz4KPC9zdmc+Cg==";
export { SvgMark2 as ReactComponent };